import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HStack, VStack } from "native-base";
import { DeviceOwnership, DeviceOperation as Operation, logisticsForHumans, } from "@madmedical/medical";
import { useEffect } from "react";
import { useWatchForm } from "@madmedical/form";
import { formatDate } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import FormDateInput from "../../form/FormDateInput";
import SubmitButton from "../../form/SubmitButton";
import FormControl from "../../form/FormControl";
import Button from "../../atoms/Button";
import ModalContent from "../../molecules/ModalContent";
import FormSelect from "../../form/FormSelect";
import FormTextAreaControl from "../../form/FormTextAreaControl";
import FormError from "../../form/FormError";
const CallCenterDeviceModalForm = ({ operations, patients, institutions, deviceTypes, onClose, onSubmitPress, isSuccess, isSubmitting, }) => {
    const operation = useWatchForm({
        name: "operation",
    });
    const { t } = useTranslation();
    useEffect(() => {
        if (isSuccess) {
            onClose();
        }
    }, [isSuccess, onClose]);
    return (_jsx(ModalContent, Object.assign({ header: t("editDevice"), footer: _jsxs(HStack, Object.assign({ space: 2 }, { children: [_jsx(Button, Object.assign({ variant: "outlined", size: "md", onPress: onClose }, { children: t("cancel") })), _jsx(SubmitButton, { onPress: onSubmitPress, isLoading: isSubmitting, label: t("save") })] })) }, { children: _jsxs(VStack, Object.assign({ space: "6" }, { children: [_jsx(FormError, {}), operation !== Operation.Create && (_jsx(FormSelect, { name: "operation", label: t("operation"), isRequired: true, choices: operations.map((operation) => ({
                        value: operation,
                        label: logisticsForHumans(operation),
                    })) })), _jsxs(HStack, Object.assign({ space: "3" }, { children: [operation === Operation.Create && deviceTypes && (_jsx(FormSelect, { name: "deviceTypeId", label: t("type"), choices: deviceTypes.map(({ id, name, manufacturer }) => ({
                                value: id,
                                label: `${manufacturer.forHumans} ${name}`,
                            })), isRequired: true })), _jsx(FormControl, { name: "serialNumber", label: t("serialNumber"), isRequired: true, flex: "1", type: "text" })] })), _jsx(HStack, Object.assign({ space: "3" }, { children: _jsx(FormDateInput, { name: "warrantyExpiresAt", label: t("endOfGuarantee") }) })), operation === Operation.Ordered && (_jsxs(HStack, Object.assign({ space: "3" }, { children: [patients && (_jsx(FormSelect, { name: "patientId", label: t("patient"), isRequired: true, choices: patients.map(({ userId, fullName, birthDate }) => ({
                                value: userId,
                                label: `${fullName} (${birthDate
                                    ? formatDate(birthDate)
                                    : "–"})`,
                            })) })), _jsx(FormSelect, { name: "ownership", label: t("settlement"), isRequired: true, choices: Object.values(DeviceOwnership).map((ownership) => ({
                                value: ownership,
                                label: logisticsForHumans(ownership),
                            })) })] }))), [Operation.Create, Operation.ToStorage].includes(operation) &&
                    institutions && (_jsx(FormSelect, { name: "institutionId", label: t("institution"), choices: [
                        { value: "", label: t("ownWarehouse") },
                        ...institutions.map(({ id, name }) => ({
                            value: id,
                            label: name,
                        })),
                    ] })), _jsx(FormTextAreaControl, { name: "note", label: t("comment") })] })) })));
};
export default CallCenterDeviceModalForm;
